export default __webpack_public_path__ + "static/media/ic-dropdown.3e45abf0.svg";